/**
 * @generated SignedSource<<ad7dd93fc6561c33d009bbb1e042d586>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeTxnsInputObject = {
  name?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  stakeholderId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type pnlCellPanel_AttributeTxnsMutation$variables = {
  input: AttributeTxnsInputObject;
};
export type pnlCellPanel_AttributeTxnsMutation$data = {
  readonly attributeTxns: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type pnlCellPanel_AttributeTxnsMutation = {
  response: pnlCellPanel_AttributeTxnsMutation$data;
  variables: pnlCellPanel_AttributeTxnsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlCellPanel_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pnlCellPanel_AttributeTxnsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributeTxnsMutationPayload",
        "kind": "LinkedField",
        "name": "attributeTxns",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a96bd99dc5d5582dc7e01caf34835296",
    "id": null,
    "metadata": {},
    "name": "pnlCellPanel_AttributeTxnsMutation",
    "operationKind": "mutation",
    "text": "mutation pnlCellPanel_AttributeTxnsMutation(\n  $input: AttributeTxnsInputObject!\n) {\n  attributeTxns(input: $input) {\n    stakeholder {\n      id\n      name\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ab72bd13e6c4b35afec8a7b87480190";

export default node;
